export type HeaderPage = 'skills' | 'resources' | 'community'

export const TAB_ITEMS: HeaderPage[] = ['skills', 'resources', 'community']

export const MASK_POSITION_CLASS: Record<HeaderPage, string> = {
  skills: '[mask-position:left_center,right_0_center]',
  resources: '[mask-position:left_center,right_-195px_center]',
  community: '[mask-position:left_center,right_-390px_center]',
}
